import { render, staticRenderFns } from "./InpaintingEditor.vue?vue&type=template&id=488ad0c8&scoped=true"
import script from "./InpaintingEditor.vue?vue&type=script&lang=ts"
export * from "./InpaintingEditor.vue?vue&type=script&lang=ts"
import style0 from "./InpaintingEditor.vue?vue&type=style&index=0&id=488ad0c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488ad0c8",
  null
  
)

export default component.exports